import WarnIcon from 'common/components/dialog-function/WarnIcon';
import StyledModal from 'common/components/modal/StyledModal';

const ModalConfirm = ({ children, ...props }) => {
  return (
    <StyledModal
      title={null}
      width={420}
      bodyStyle={{ paddingTop: 24 }}
      {...props}
    >
      <WarnIcon />
      {children}
    </StyledModal>
  );
};

export default ModalConfirm;
